import { ReactNode } from 'react'
import { VariableIcon, RawVariableIcon, FunctionIcon } from '../icons'
import { isVariablePath, pathToLabel, isHelperExpression, parseHelperExpression, helperPillLabel } from './variableUtils'
import './VariableTextInput.css'

interface VariableDisplayProps {
    value: string
}

export default function VariableDisplay({ value }: VariableDisplayProps) {
    const parts = value.split(/(\{\{\{[^}]+\}\}\}|\{\{[^}]+\}\})/)
    const nodes: ReactNode[] = []

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i]
        if (!part) continue
        const tripleMatch = part.match(/^\{\{\{(.+?)\}\}\}$/)
        const match = tripleMatch ?? part.match(/^\{\{(.+?)\}\}$/)
        if (match) {
            const inner = match[1].trim()
            if (isVariablePath(inner)) {
                nodes.push(
                    <span key={i} className="pill-content variable-pill-content">
                        {tripleMatch ? <RawVariableIcon /> : <VariableIcon />}
                        {pathToLabel(inner)}
                    </span>,
                )
            } else if (isHelperExpression(inner)) {
                const parsed = parseHelperExpression(inner)
                if (parsed) {
                    nodes.push(
                        <span key={i} className="pill-content helper-pill-content">
                            <FunctionIcon />
                            {helperPillLabel(parsed.name, parsed.args)}
                        </span>,
                    )
                } else {
                    nodes.push(part)
                }
            } else {
                nodes.push(part)
            }
        } else {
            nodes.push(part)
        }
    }

    return <span className="variable-display">{nodes}</span>
}
